/**
 * @param {string} [search=window.location.search] 
 * @returns {URLSearchParams}
 */
export function getUtmParams(search = window.location.search) {
  const source = new URLSearchParams(search);
  const utm = new URLSearchParams();

  for (const [key, value] of source.entries()) {
    if (key.toLowerCase().startsWith('utm_')) {
      utm.append(key, value);
    }
  }

  return utm;
}

/**
 *
 * @param {string} targetHref 
 * @param {URLSearchParams} [utmParams=getUtmParams()] 
 * @returns {string} 
 */
export function mergeUtmIntoUrl(targetHref, utmParams = getUtmParams()) {
  if (![...utmParams].length) return targetHref;

  let target;
  try {
    target = new URL(targetHref, window.location.href);
  } catch {
    return targetHref;
  }

  for (const [key, value] of utmParams.entries()) {
    if (!target.searchParams.has(key)) {
      target.searchParams.set(key, value);
    }
  }

  return target.toString();
}

/**
 * @param {string} [selector]
 */
export function forwardUtmToLinks(
  selector = 'a[href*="telesurveillance.nexecur.fr/diagnostic"]'
) {
  const utmParams = getUtmParams();
  if (![...utmParams].length) return; 

  document.querySelectorAll(selector).forEach((link) => {
    link.href = mergeUtmIntoUrl(link.getAttribute('href'), utmParams);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => forwardUtmToLinks());
} else {
  forwardUtmToLinks();
}
